import { Status } from '@/common/enumerations';
import {
  IJobModel,
  IJobItemScheduleModel,
  IJobItemModel,
  IJobItemActivityModel,
  IJobNoteModel,
  IEmployeeModel,
  IServiceTypeModel,
  IDocumentModel,
  ITravelTimeModel,
  IInvoiceBatchModel,
  IInvoiceModel
} from './api.service';

export class JobItemScheduleUpdatedMessage {
  constructor(jobGid: string, jobItemGid: string, data: IJobItemScheduleModel) {
    this.jobGid = jobGid;
    this.jobItemGid = jobItemGid;
    this.data = data;
  }
  public jobItemGid: string = '';
  public jobGid: string = '';
  public data: IJobItemScheduleModel | null = null;
}

export class JobItemStatusChangedMessage {
  constructor(jobGid: string, oldStatus: Status, newStatus: Status, data: IJobItemModel) {
    this.jobGid = jobGid;
    this.oldStatus = oldStatus;
    this.newStatus = newStatus;
    this.data = data;
  }

  public jobGid: string = '';
  public data: IJobItemModel | null = null;
  public oldStatus: Status = Status.Pending;
  public newStatus: Status = Status.Pending;
}

export class JobItemUpdatedMessage {
  constructor(jobGid: string, data: IJobItemModel) {
    this.jobGid = jobGid;
    this.data = data;
  }
  public jobGid: string = '';
  public data: IJobItemModel | null = null;
}

export class JobItemCreatedMessage {
  constructor(jobGid: string, data: IJobItemModel) {
    this.jobGid = jobGid;
    this.data = data;
  }
  public jobGid: string = '';
  public data: IJobItemModel | null = null;
}

export class JobItemCancelledMessage {
  constructor(jobGid: string, data: IJobItemModel) {
    this.jobGid = jobGid;
    this.data = data;
  }
  public jobGid: string = '';
  public data: IJobItemModel | null = null;
}

export class JobUpdatedMessage {
  constructor(data: IJobModel) {
    this.data = data;
  }
  public data: IJobModel | null = null;
}

export class JobItemActivityCreatedMessage {
  constructor(jobItemGid: string, data: IJobItemActivityModel) {
    this.data = data;
    this.jobItemGid = jobItemGid;
  }
  public jobItemGid: string = '';
  public data: IJobItemActivityModel | null = null;
}

export class JobItemScheduleAssignmentUpdatedMessage {
  constructor(data: IJobItemScheduleModel) {
    this.data = data;
  }
  public data: IJobItemScheduleModel | null = null;
}

export class JobItemRescheduledMessage {
  constructor(data: IJobItemScheduleModel) {
    this.data = data;
  }
  public data: IJobItemScheduleModel | null = null;
}
export class JobNoteUpdatedMessage {
  constructor(jobGid: string, data: IJobNoteModel) {
    this.jobGid = jobGid;
    this.data = data;
  }
  public jobGid: string = '';
  public data: IJobNoteModel | null = null;
}

export class JobNoteCreatedMessage {
  constructor(jobGid: string, data: IJobNoteModel) {
    this.data = data;
    this.jobGid = jobGid;
  }
  public jobGid: string = '';
  public data: IJobNoteModel | null = null;
}

export class JobDocumentUpdatedMessage {
  constructor(jobGid: string, data: IDocumentModel) {
    this.jobGid = jobGid;
    this.data = data;
  }
  public jobGid: string = '';
  public data: IDocumentModel | null = null;
}

export class JobDocumentCreatedMessage {
  constructor(jobGid: string, data: IDocumentModel) {
    this.data = data;
    this.jobGid = jobGid;
  }
  public jobGid: string = '';
  public data: IDocumentModel | null = null;
}

export class EmployeeCreatedMessage {
  constructor(data: IEmployeeModel) {
    this.data = data;
  }
  public data: IEmployeeModel | null = null;
}


export class EmployeeUpdatedMessage {
  constructor(data: IEmployeeModel) {
    this.data = data;
  }
  public data: IEmployeeModel | null = null;
}

export class EmployeeDeletedMessage {
  constructor(data: IEmployeeModel) {
    this.data = data;
  }
  public data: IEmployeeModel | null = null;
}


export class ServiceTypeCreatedMessage {
  constructor(data: IServiceTypeModel) {
    this.data = data;
  }
  public data: IServiceTypeModel | null = null;
}


export class ServiceTypeUpdatedMessage {
  constructor(data: IServiceTypeModel) {
    this.data = data;
  }
  public data: IServiceTypeModel | null = null;
}

export class TravelTimeCreatedMessage {
  constructor(data: ITravelTimeModel) {
    this.data = data;
  }
  public data: ITravelTimeModel | null = null;
}


export class TravelTimeUpdatedMessage {
  constructor(data: ITravelTimeModel) {
    this.data = data;
  }
  public data: ITravelTimeModel | null = null;
}

export class InvoiceBatchCreatedMessage {
  constructor(data: IInvoiceBatchModel) {
    this.data = data;
  }
  public data: IInvoiceBatchModel | null = null;
}


export class InvoiceBatchUpdatedMessage {
  constructor(data: IInvoiceBatchModel) {
    this.data = data;
  }
  public data: IInvoiceBatchModel | null = null;
}


export class InvoiceCreatedMessage {
  constructor(data: IInvoiceModel) {
    this.data = data;
  }
  public data: IInvoiceModel | null = null;
}


export class InvoiceUpdatedMessage {
  constructor(data: IInvoiceModel) {
    this.data = data;
  }
  public data: IInvoiceModel | null = null;
}
